"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mailboxMessageConfigurationOptions_1 = require("owa-service/lib/factory/mailboxMessageConfigurationOptions");
var setMailboxMessageConfigurationRequest_1 = require("owa-service/lib/factory/setMailboxMessageConfigurationRequest");
var setMailboxMessageConfigurationOperation_1 = require("owa-service/lib/operation/setMailboxMessageConfigurationOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function setMailboxMessageConfiguration(newOptions) {
    return setMailboxMessageConfigurationOperation_1.default(setMailboxMessageConfigurationRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: mailboxMessageConfigurationOptions_1.default(newOptions),
    }));
}
exports.default = setMailboxMessageConfiguration;
//# sourceMappingURL=setMailboxMessageConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/services/setMailboxMessageConfiguration.js
// module id = 1827
// module chunks = 2 39 105 108